import { initModal } from '../modal/modal.js';

const modal = document.querySelector('#sommaire-modal');
const btn = document.querySelector('.sommaire-bouton');

initModal(modal, btn);

modal?.addEventListener('click', (e) => {
  if (e.target.tagName === 'A') {
    // On reprend le fonctionnement de modal.js
    modal.style.display = 'none';
  }
});

const btnWrapper = document.querySelector('.sommaire-bouton-wrapper');
if (btnWrapper) {
  const texteLibreEl = document.querySelector(
    '.dossier-somation-right-contenu .clampLines',
  );
  let texteLibreElY = texteLibreEl?.offsetTop;
  if (texteLibreElY != null) {
    // Sur un scroll on modifie la class du bouton de sommaire
    document.addEventListener(
      'scroll',
      () => {
        btnWrapper.classList.toggle(
          'stickity-stick',
          // On veut que le sommaire soit sticky uniquement sur la longueur du texte libre
          window.scrollY >= texteLibreElY &&
            window.scrollY <= texteLibreElY + texteLibreEl.offsetHeight,
        );
      },
      { passive: true },
    );

    window.addEventListener(
      'resize',
      () => (texteLibreElY = texteLibreEl.offsetTop),
    );
  }
}

// Ajoute un scroll quand on clic sur un élément du sommaire
document
  .querySelectorAll('.dossier-contenu a.noteNumber, .richtext-wrapper a.note')
  .forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault();

      const targetName = element.getAttribute('href').substring(1);
      const target = element
        .closest('.dossier-contenu')
        .querySelector(`a[name="${targetName}"]`);

      const sommaireBtnWrapper = document.querySelector(
        '.sommaire-bouton-wrapper',
      );
      window.scroll({
        top: target.offsetTop - (sommaireBtnWrapper?.offsetHeight ?? 0) / 2,
        behavior: 'smooth',
      });
    });
  });
